import React, { useState } from 'react';
import { School } from '@material-ui/icons';
import { Navigate } from 'react-router';
import CardHeader from '../../components/Card/CardHeader';
import CardBody from '../../components/Card/CardBody';
import CustomTable from '../../components/Table/Table';
import Lang from '../../variables/i18n';
import CardFooter from '../../components/Card/CardFooter';
import { CreateButton } from '../../components/CommonButtons';
import Card from '../../components/Card/Card';
import { doDelete, SCModules } from '../../components/supercore/api';
import SchoolDetails from '../../components/SchoolDetails';
import GenericActions from '../../components/GenericActions';
import DeleteModal from '../../components/DeleteModal';
import { concatSchool } from '../../utils';
import CardTitle from '../../components/CardTitle';
import { useQueryMultiple } from '../../components/ReactQueryUtils';

const SchoolsView = () => {
	const [pendingState, setPending] = useState(false);
	const [forceRefresh, setForceRefresh] = useState(Date.now());
	const [deleteModal, setDeleteModal] = useState(undefined);

	const [data, isLoading] = useQueryMultiple(
		SCModules.schools,
		setPending,
		forceRefresh
	);

	const pending = pendingState || isLoading;

	const entries = data.map(
		({
			id,
			name,
			schoolName,
			instName,
			shortName,
			ordersCount = 0,
			eventsCount = 0,
		}) => [
			instName,
			schoolName,
			name,
			shortName,
			eventsCount,
			ordersCount,
			<GenericActions
				id={id}
				view
				handleDelete={() => setDeleteModal(id)}
				deleteDisabled={ordersCount > 0 || eventsCount > 0}
			/>,
		]
	);

	return (
		<Card>
			<CardHeader>
				<CardTitle title={SchoolsRoute.name} icon={<School />}>
					<CreateButton />
				</CardTitle>
			</CardHeader>
			<CardBody>
				<CustomTable
					pending={pending}
					empty={!pending && entries.length === 0}
					tableHead={[
						'Ίδρυμα',
						'Σχολή',
						Lang.name,
						'Συντομονύμιο',
						'Αρ. Ορκομοσιών',
						'Αρ. Παραγγελιών',
						'', // actions toolbar
					]}
					tableData={entries}
				/>
			</CardBody>
			<CardFooter>
				<span />
			</CardFooter>
			<DeleteModal
				open={!!deleteModal}
				onClick={async () => {
					try {
						setPending(true);
						await doDelete({ module: SCModules.schools, path: deleteModal });
					} finally {
						setForceRefresh(forceRefresh + 1);
						setPending(false);
					}
				}}
				onClose={() => setDeleteModal(undefined)}
			>
				{deleteModal && concatSchool(data.find(({ id }) => id === deleteModal))}
			</DeleteModal>
		</Card>
	);
};

const SchoolsRoute = {
	path: 'schools',
	name: 'Σχολές & Ιδρύματα',
	icon: School,
	children: [
		{ path: '/', element: <SchoolsView /> },
		{ path: 'create', element: <SchoolDetails create /> },
		{ path: 'view', element: <Navigate to="../" /> },
		{ path: 'view/:eventId', element: <SchoolDetails /> },
	],
};

export default SchoolsRoute;
